<template>
    <div class="flex items-center justify-between gap-4 px-4 py-2.5">
        <dt class="text-sm text-muted">{{ label }}</dt>
        <dd class="text-sm font-medium text-default text-right">{{ value || '—' }}</dd>
    </div>
</template>

<script lang="ts" setup>
    defineProps<{
        label: string
        value: string
    }>()
</script>
